module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/lZhLud/tc-custom/9781631942938.jpg?1720017201778",
      "alt": "This image is the cover for the book Fire, The John Grey Mysteries"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Fire, The John Grey Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("It’s the Autumn of 1666, and the Great Fire is still burning, the ashes of hundreds of houses and shops and St. Paul’s Cathedral choking the air. The people, too, are choking, raging at the French, the Dutch, at the foreigners who—they are certain—lit the torch. Lord Arlington, the Secretary of State, might conceivably be interested in harnessing this anger; it can be so useful, at times, to have the population united in loathing of a common enemy. But this is not one of those times. And inconveniently, a Frenchman—clearly an insane Frenchman—has confessed to setting the fire. He did it with an accomplice, he says. And he subsequently killed the accomplice. It’s all most irritating for Arlington, or it would be if he didn’t have John Grey on call. Go poke around the smoldering ruins, Arlington says. Find me a convenient fall guy. Make this problem go away. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      L.C. Tyler\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Len (L.C.) Tyler is an award-winning British mystery writer, author of both a contemporary comedic series about a hapless writer and his nosy agent and a historical mystery series set during Oliver Cromwell's rule. Tyler was educated at Oxford and has lived in Malaysia, Thailand, Hong Kong, Denmark, and Norway. His first two Ethelred and Elsie novels, The Herring Seller’s Apprentice and Ten Little Herrings, were both nominated for Edgar Awards. He currently lives in London.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Felony & Mayhem Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0